import { proxyCustomElement, HTMLElement, h } from '@stencil/core/internal/client';
import { W as WppIcon } from './WppIcon.js';

const wppIconCss = ":host{display:-ms-inline-flexbox;display:inline-flex;color:var(--wpp-prop-icon-color)}";

const WppIconBorderTopBottomDouble$1 = /*@__PURE__*/ proxyCustomElement(class WppIconBorderTopBottomDouble extends HTMLElement {
  constructor() {
    super();
    this.__registerHost();
    this.__attachShadow();
    this.size = 'm';
    this.width = undefined;
    this.height = undefined;
    this.color = 'var(--wpp-icon-color)';
  }
  render() {
    return (h(WppIcon, { name: "wpp-icon-border-top-bottom-double", width: this.width, height: this.height, size: this.size, color: this.color }, h("path", { d: "M5.99996 4.50195C5.36604 4.50195 4.82397 4.89519 4.60436 5.45103C4.59564 5.48251 4.58476 5.51377 4.57165 5.54466C4.40983 5.92587 3.96962 6.10373 3.58841 5.94191C3.20723 5.78011 3.02937 5.33998 3.1911 4.95879H3.18629C3.61007 3.8162 4.70992 3.00195 5.99996 3.00195H14C15.29 3.00195 16.3898 3.8162 16.8136 4.95879H16.8105C16.9723 5.34 16.7944 5.78019 16.4132 5.942C16.032 6.10381 15.5918 5.92596 15.4299 5.54474L15.4257 5.53446C15.4167 5.51245 15.4089 5.49026 15.4021 5.46794C15.1869 4.90318 14.6403 4.50195 14 4.50195H5.99996ZM3.75 11.0007C3.33579 11.0007 3 10.6649 3 10.2507V8.75073C3 8.33652 3.33579 8.00073 3.75 8.00073C4.16421 8.00073 4.5 8.33652 4.5 8.75073V10.2507C4.5 10.6649 4.16421 11.0007 3.75 11.0007ZM16.25 11.0007C15.8358 11.0007 15.5 10.6649 15.5 10.2507V8.75073C15.5 8.33652 15.8358 8.00073 16.25 8.00073C16.6642 8.00073 17 8.33652 17 8.75073V10.2507C17 10.6649 16.6642 11.0007 16.25 11.0007ZM3.75 15.5007C3.33579 15.5007 3 15.8365 3 16.2507C3 16.6649 3.33579 17.0007 3.75 17.0007H16.25C16.6642 17.0007 17 16.6649 17 16.2507C17 15.8365 16.6642 15.5007 16.25 15.5007H3.75ZM3 13.7507C3 13.3365 3.33579 13.0007 3.75 13.0007H16.25C16.6642 13.0007 17 13.3365 17 13.7507C17 14.1649 16.6642 14.5007 16.25 14.5007H3.75C3.33579 14.5007 3 14.1649 3 13.7507Z", fill: "currentColor" })));
  }
  static get registryIs() { return "wpp-icon-border-top-bottom-double-v2-21-0"; }
  static get style() { return wppIconCss; }
}, [1, "wpp-icon-border-top-bottom-double", "wpp-icon-border-top-bottom-double-v2-21-0", {
    "size": [1],
    "width": [2],
    "height": [2],
    "color": [1]
  }]);
function defineCustomElement$1() {
  if (typeof customElements === "undefined") {
    return;
  }
  const components = ["wpp-icon-border-top-bottom-double-v2-21-0"];
  components.forEach(tagName => { switch (tagName) {
    case "wpp-icon-border-top-bottom-double-v2-21-0":
      if (!customElements.get(tagName)) {
        customElements.define(tagName, WppIconBorderTopBottomDouble$1);
      }
      break;
  } });
}

const WppIconBorderTopBottomDouble = WppIconBorderTopBottomDouble$1;
const defineCustomElement = defineCustomElement$1;

export { WppIconBorderTopBottomDouble, defineCustomElement };
